MicroModal.init();

$( "#ctaNewsletter" ).click(function() {
    MicroModal.show('modalNewsletter');
});
